import { render, staticRenderFns } from "./BtnSaveSelectionAs.vue?vue&type=template&id=8b7c2404&scoped=true"
import script from "./BtnSaveSelectionAs.vue?vue&type=script&lang=js"
export * from "./BtnSaveSelectionAs.vue?vue&type=script&lang=js"
import style0 from "./BtnSaveSelectionAs.vue?vue&type=style&index=0&id=8b7c2404&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7c2404",
  null
  
)

export default component.exports